//npm packages
import React, { Fragment } from 'react';
import { Button, ButtonGroup } from 'reactstrap';

const renderStatusButton = ({ items, value, className, onClick }) => {
  let toReturn = [];
  for (let obj of items) {
    let isActive = false;
    if (Array.isArray(obj.activeCondition)) {
      isActive = obj.activeCondition.includes(value);
    } else {
      isActive = obj.activeCondition === value;
    }
    toReturn.push(
      <Button
        type="button"
        title={obj.title}
        className={className}
        color={(isActive && 'primary') || 'secondary'}
        onClick={() => onClick(obj.title)}
      >
        {obj.btnContent}
      </Button>
    );
  }
  return toReturn;
};
export default ({ input, ...rest }) => {
  const { meta, items, className, onClick } = rest || {};
  const { touched, error, warning } = meta || {};
  const { value } = input;
  let child = renderStatusButton({ items, value, className, onClick });
  return (
    <Fragment>
      <ButtonGroup className="ml-4 mt-2">{child}</ButtonGroup>
      {touched &&
        ((error && <span className="required-color-red">{error}</span>) ||
          (warning && <span className="warning-color">{warning}</span>))}
    </Fragment>
  );
};
